import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { QualityEvaluationRequest, QualityEvaluationStatus } from '../models/quality-evaluation';

/** An evaluation starts in the background and is polled until it is done. */
@Injectable({
  providedIn: 'root'
})
export class QualityEvaluationService {
  baseUrl = environment.apiEndpoint + '/qualityevaluation/';

  constructor(private http: HttpClient) { }

  start(request: QualityEvaluationRequest): Observable<QualityEvaluationStatus> {
    return this.http.post<QualityEvaluationStatus>(this.baseUrl, request);
  }

  getStatus(runId: string): Observable<QualityEvaluationStatus> {
    return this.http.get<QualityEvaluationStatus>(this.baseUrl + encodeURIComponent(runId));
  }
}
